// extracted by mini-css-extract-plugin
export default {"content":"style_content__uPTBn","itemName":"style_itemName__GbutB"};